const META_PIXEL_ID = "1410773702285913";

export function initMetaPixel() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.fbq) return;

  /* Meta Pixel base loader */
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

export function trackMetaEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", eventName, params);
    }
  } catch (_) {
    // Analytics must never interrupt the customer experience.
  }
}

export function trackMetaStandardEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
  } catch (_) {
    // Analytics must never interrupt the customer experience.
  }
}
